import { ReduxActionTypes } from "ee/constants/ReduxActionConstants";
import { createReducer } from "utils/ReducerUtils";
import { groupsReducers } from "./groupsReducer";
import { rolesReducers } from "./rolesReducer";
import { userReducers } from "./usersReducer";
import type {
  GroupProps,
  RoleProps,
  UserProps,
} from "ee/pages/AdminSettings/AccessControl/types";

export const initialState: AclReduxState = {
  isLoading: false,
  isSavingName: false,
  isEditing: false,
  users: {
    content: [],
    count: 0,
    startIndex: 0,
    total: 0,
  },
  groups: [],
  roles: [],
  selectedUser: null,
  selectedGroup: null,
  selectedRole: null,
  inviteOptions: {
    roles: [],
    groups: [],
  },
  iconLocations: [],
};

export interface AclReduxState {
  isLoading: boolean;
  isSavingName: boolean;
  isEditing: boolean;
  users: {
    content: UserProps[];
    count: number;
    startIndex: number;
    total: number;
  };
  groups: GroupProps[];
  roles: RoleProps[];
  selectedUser: UserProps | null;
  selectedGroup: GroupProps | null;
  selectedRole: RoleProps | null;
  inviteOptions: {
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    roles: any[];
    // TODO: Fix this the next time the file is edited
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    groups: any[];
  };
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  iconLocations: any[];
}

export const handlers = {
  ...userReducers,
  ...groupsReducers,
  ...rolesReducers,
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [ReduxActionTypes.ACL_IS_EDITING]: (state: any, action: any) => ({
    ...state,
    isEditing: action.payload,
  }),
};

export default createReducer(initialState, handlers);
